if (!customElements.get('pdp-before-after')) {
  customElements.define(
    'pdp-before-after',
    class PdpBeforeAfter extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('.pdp-before-after__range');
        if (!this.range) return;
        this.onInput = () => this.style.setProperty('--position', `${this.range.value}%`);
        this.onPointerDown = (event) => {
          if (event.button !== 0) return;
          this.setPointerCapture(event.pointerId);
          this.moveTo(event.clientX);
        };
        this.onPointerMove = (event) => {
          if (this.hasPointerCapture(event.pointerId)) this.moveTo(event.clientX);
        };
        this.range.addEventListener('input', this.onInput);
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('pointermove', this.onPointerMove);
        this.onInput();
      }

      disconnectedCallback() {
        this.range?.removeEventListener('input', this.onInput);
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('pointermove', this.onPointerMove);
      }

      moveTo(clientX) {
        const rect = this.getBoundingClientRect();
        const percent = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
        this.range.value = Math.round(percent);
        this.onInput();
      }
    }
  );
}

// Benefit title, benefits and images can be set per variant, so re-render the section when the variant changes.
if (!customElements.get('pdp-benefits')) {
  customElements.define(
    'pdp-benefits',
    class PdpBenefits extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-variant-aware') || typeof subscribe !== 'function') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variantId = event?.data?.variant?.id;
          if (variantId) this.refresh(variantId);
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      refresh(variantId) {
        const sectionId = this.dataset.sectionId;
        this.abortController?.abort();
        this.abortController = new AbortController();
        fetch(`${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`, {
          signal: this.abortController.signal,
        })
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const source = html.querySelector('pdp-benefits');
            if (source) this.innerHTML = source.innerHTML;
          })
          .catch(() => {});
      }
    }
  );
}
